<template>
  <Page padding="large" class="bg-linear-to-tl from-1% from-iris-900 to-slate-700 to-80%">

    <Box v-slot="{ breakpoint }">
      <Box full marginBottom="medium" gapY="small" :shouldCollapse="breakpoint === 'xs'">
        <!-- Core Component Selector -->
        <Box shouldCollapse class="sm:w-[14rem]">
          <p class="text-sm text-center text-slate-100 dark:text-slate-200">Resuable Components</p>

          <!-- Cascade Select attempt -->
          <CascadeSelect
            v-model="currentPlayground"
            :options="playgrounds"
            optionLabel="label"
            optionValue="value"
            optionGroupLabel="name"
            :optionGroupChildren="['components']"
            style="min-width: 14rem"
            placeholder="Select a playground"
          />
        </Box>

        <p class="flex-1 self-center text-center text-white text-2xl md:text-3xl order-first sm:order-none">Helper UI Playground</p>
      </Box>
    </Box>

    <!-- Dynamic component injection -->
    <component :is="playgroundToDisplay"></component>
  </Page>
</template>

<script setup>
import { ref, computed, shallowRef } from 'vue'
import { Page, Box } from '@/components/Core/Layout'
import ButtonPlayground from './ButtonPlayground.vue'
import TextPlayground from './TextPlayground.vue'
import { Icon } from '@iconify/vue'
import CascadeSelect from '@/components/Core/Form/CascadeSelect.vue'

const currentPlayground = ref('Button')

/**
 * With Cascade select, it expects the options to be in an Array of Objects format
 * Each object must have a [name] key value which is the grouping section
 * As well as an components Array.
 *
 *
 * We are using [shallowRef()] around each component to avoid a console.warning for a
 * potential reacitivy issue with using components inside the <component /> element.
 * The shallowRef() removes the console warning.
*/
const playgrounds = ref([
  // {
  //   name: 'Form',
  //   components: []
  // },
  // {
  //   name: 'Layout',
  //   components: []
  // },
  {
    name: 'General',
    components: [
      { label: 'Button', value: 'Button', component: shallowRef(ButtonPlayground) },
      { label: 'Text', value: 'Text', component: shallowRef(TextPlayground) }
    ]
  },
])

/**
 * Because the Options array is objects with nestest Array of components. We have to do two loops
 * through in order to get the component from each object in the Components array
*/
const playgroundToDisplay = computed(() => {
  let playground = null

  for (const section of playgrounds.value) {
    for (const component of section.components) {
      if (component.value === currentPlayground.value) {
        playground = component.component
      }
    }
  }

  return playground
})
</script>